import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
const Panel = lazy(() =>
  import('./SearchPanel').then((module) => ({ default: module.SearchPanel })),
);
export function CommandPalette() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const origin = useRef<HTMLElement | null>(null);
  const show = () => {
    origin.current = trigger.current;
    setOpen(true);
  };
  useEffect(() => {
    if (open) dialog.current?.showModal();
    else {
      dialog.current?.close();
      origin.current?.focus();
    }
  }, [open]);
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (
        (e.metaKey || e.ctrlKey) &&
        !e.altKey &&
        e.code === 'KeyK' &&
        !document.querySelector('dialog[open]')
      ) {
        e.preventDefault();
        origin.current = document.activeElement as HTMLElement | null;
        setOpen(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
  return (
    <>
      <Button ref={trigger} onClick={show}>
        {t('search.title')}
        <kbd className="hidden text-xs text-muted md:inline">⌘/Ctrl K</kbd>
      </Button>
      <dialog
        ref={dialog}
        onCancel={() => setOpen(false)}
        onClose={() => setOpen(false)}
        aria-labelledby="search-dialog-title"
        className="m-auto max-h-[calc(100dvh-2rem)] w-[min(48rem,calc(100vw-2rem))] overflow-y-auto rounded-card border border-line bg-surface p-5 text-ink backdrop:bg-black/40"
      >
        <div className="mb-4 flex items-center justify-between gap-3">
          <h2 id="search-dialog-title" className="font-serif text-xl">
            {t('search.title')}
          </h2>
          <Button onClick={() => setOpen(false)}>{t('common.close')}</Button>
        </div>
        {open && (
          <Suspense fallback={<p role="status">{t('common.loading')}</p>}>
            <Panel onNavigate={() => setOpen(false)} />
          </Suspense>
        )}
      </dialog>
    </>
  );
}
